<template>
  <base-page
    :title="'Events'"
  >
    <template #actionButton>
      <event-create-update-dialog>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon>add</v-icon> Add Event
          </v-btn>
        </template>
      </event-create-update-dialog>
    </template>
    <template #main>
      <event-tree />
      <v-divider class="my-3" />
      <event-archived-list />
    </template>
  </base-page>
</template>

<script>
import { mapActions } from 'vuex'
import EventArchivedList from "../../components/Event/EventArchivedList"
import EventCreateUpdateDialog from "../../components/Event/EventCreateUpdateDialog"
import EventTree from "../../components/Event/EventTree"
import BasePage from "../BasePage"

export default {
  components: {
    EventArchivedList,
    BasePage,
    EventCreateUpdateDialog,
    EventTree
  },
  created() {
    this.initEvents()
  },
  methods: {
    ...mapActions(['initEvents'])
  }
}
</script>
